export default "__VITE_PUBLIC_ASSET__2fd6ce0c__"